import { Button, Checkbox, Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex)`
  max-height: 360px;
`;

export const Content = styled(Flex)`
  overflow: auto;
`;

export const FooterButton = styled(Button)`
  flex: 1;
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  flex-direction: column;
`;
